import React from 'react';
import Account from "./Account";
import {withRouter} from "./withRouter";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            email: null,
            emailConfirmationEmailWasSent: false
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        const body = {'email': e.target.email.value, 'first_name': e.target.first_name.value, 'last_name': e.target.last_name.value, 'password': e.target.password.value};

        fetch(process.env.REACT_APP_API_URL + '/my-account/register', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json'}
        }).then(res => res.json())
            .then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    email: result.email,
                    emailConfirmationEmailWasSent: result.email_confirmation_token != null
                });
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        );
    }

    render() {
        const { error, isLoaded, email, emailConfirmationEmailWasSent } = this.state;

        var content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (isLoaded && emailConfirmationEmailWasSent) {
            content = <h3>Confirmation email was sent to {email}</h3>
        } else {
            content = <Row className="vh-100 d-flex justify-content-center align-items-center">
                <Col md={8} lg={6} xs={12}>
                    <div className="border border-3 border-primary"></div>
                    <Card className="shadow">
                        <Card.Body>
                            <div className="mb-3 mt-md-4">
                                <h2 className="fw-bold mb-2 text-uppercase ">ES</h2>
                                <p className=" mb-5">Come and see why you should be on Easy Street</p>
                                <div className="mb-3">
                                    <Form onSubmit={this.handleSubmit.bind(this)}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="text-center">
                                                Email address
                                            </Form.Label>
                                            <Form.Control name="email" type="email" placeholder="Enter email" />
                                        </Form.Group>

                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicPassword"
                                        >
                                            <Form.Label>First name</Form.Label>
                                            <Form.Control name="first_name"  type="text" placeholder="First name" />
                                        </Form.Group>

                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicPassword"
                                        >
                                            <Form.Label>Last name</Form.Label>
                                            <Form.Control name="last_name"  type="text" placeholder="Last name" />
                                        </Form.Group>

                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicPassword"
                                        >
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control name="password"  type="password" placeholder="Password" />
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicCheckbox"
                                        >
                                            <p className="small">
                                                <a className="text-primary" href="/account/change-password">
                                                    Forgot password?
                                                </a>
                                            </p>
                                        </Form.Group>
                                        <div className="d-grid">
                                            <Button variant="primary" type="submit">
                                                Register
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>;
        }

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(Register);
